import { notifications } from '@mantine/notifications'
import { ADMIN_ROLE_REQUIRED } from './format'

/**
 * Feedback for a nav item or action that is visible but not built yet.
 *
 * Mirrors the pattern already established in Cartographer (`utils/comingSoon.ts`)
 * so the two apps behave identically. Showing the destination and saying plainly
 * why it is not there beats hiding it: the shape of the product stays legible,
 * and nobody files a bug against a surface that was never claimed to exist.
 */
export function showComingSoon(label: string, hint?: string) {
  notifications.show({
    title: `${label} — coming soon`,
    message: hint ?? 'This surface is planned but not built yet.',
    color: 'gray',
    autoClose: 4000,
  })
}

/**
 * Feedback for a rail entry the server says this caller may not open.
 *
 * Distinct from "coming soon" on purpose: the surface exists, and saying it is
 * not built would be false. Names the role, and quotes the server's reason when
 * it gave one — that reason says what to do next. Neutral, not red: a missing
 * role is not a fault.
 */
export function showRestricted(label: string, reason?: string | null) {
  const said = reason?.trim()
  notifications.show({
    title: `${label} — ${ADMIN_ROLE_REQUIRED}`,
    message: said
      ? `${label} is served only to holders of Lighthouse.Admin. The server says: ${said}`
      : `${label} is served only to holders of Lighthouse.Admin.`,
    color: 'gray',
    autoClose: 6000,
  })
}

/** Feedback for the Hangfire rail entry when this build was not told where the dashboard is. */
export function showHangfireUnconfigured() {
  notifications.show({
    title: 'Hangfire dashboard',
    message: 'The Hangfire dashboard address is not configured for this build (VITE_HANGFIRE_URL)',
    color: 'gray',
    autoClose: 6000,
  })
}
